import { Box, Stack } from '@mui/material'
import { FilterableTable } from '@/components/table/base'

import { MarketTypes } from '../constants'
import { OddsFilters } from '../types'
import { NoDataMessage } from './NoDataMessage'
import {
  generateThreeBallTableColumns,
  ODDS_DATA_WINNER_TABLE_COLUMNS,
  OddsDataRow
} from './oddsData.dde.table'
import { OddsDataExcelExport } from './OddsDataExcelExport'

type OddsDataContentProps = {
  areAllFiltersSelected: boolean
  tableRows: OddsDataRow[]
  playerNames: string[] | undefined
  isLoading: boolean
  isFetching: boolean
  filters: OddsFilters
  tournamentName?: string
  selectedPlayerNames?: string[]
}

export const DDE_GOLF_PRICING_ODDS_DATA_WINNER_TABLE_ID = 'dde-golf-pricing-odds-data-winner-table'
export const DDE_GOLF_PRICING_ODDS_DATA_THREE_BALL_TABLE_ID =
  'dde-golf-pricing-odds-data-three-ball-table'

export const OddsDataContent = ({
  areAllFiltersSelected,
  tableRows,
  playerNames,
  isLoading,
  isFetching,
  filters,
  tournamentName,
  selectedPlayerNames
}: OddsDataContentProps) => {
  const hasNoData = Boolean(areAllFiltersSelected && tableRows.length === 0)

  if (!areAllFiltersSelected || hasNoData) {
    return <NoDataMessage hasNoData={hasNoData} isLoading={isLoading} isFetching={isFetching} />
  }

  const marketType = filters.marketType?.value as MarketTypes

  if (filters.marketType?.value === MarketTypes.WINNER) {
    return (
      <Stack spacing={2}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2 }}>
          <OddsDataExcelExport
            tableRows={tableRows}
            filters={filters}
            tournamentName={tournamentName}
            marketType={marketType}
            selectedPlayerNames={selectedPlayerNames}
          />
        </Box>
        <FilterableTable
          disableColumnVisibility
          tableId={DDE_GOLF_PRICING_ODDS_DATA_WINNER_TABLE_ID}
          data={tableRows}
          loading={isLoading}
          fetching={isFetching}
          columns={ODDS_DATA_WINNER_TABLE_COLUMNS}
          clientSideFilters
          clientSideSortAndPagination
          defaultSort={{
            attribute: 'time',
            order: 'desc'
          }}
        />
      </Stack>
    )
  }

  if (filters.marketType?.value === MarketTypes.THREE_BALL && !!playerNames?.length) {
    return (
      <Stack spacing={2}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2 }}>
          <OddsDataExcelExport
            tableRows={tableRows}
            filters={filters}
            tournamentName={tournamentName}
            playerNames={playerNames}
            marketType={marketType}
            selectedPlayerNames={selectedPlayerNames}
          />
        </Box>
        <FilterableTable
          disableColumnVisibility
          tableId={DDE_GOLF_PRICING_ODDS_DATA_THREE_BALL_TABLE_ID}
          data={tableRows}
          loading={isLoading}
          fetching={isFetching}
          columns={generateThreeBallTableColumns(playerNames)}
          clientSideFilters
          clientSideSortAndPagination
          defaultSort={{
            attribute: 'time',
            order: 'desc'
          }}
        />
      </Stack>
    )
  }

  return null
}
